"use client";

import { useEffect } from "react";

/** Registers the offline service worker. It exists only in production builds (see scripts/). */
export function ServiceWorkerRegistration() {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) return;
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // Offline support is an enhancement; the site works without it.
    });
  }, []);
  return null;
}
